const getters = {
  newsId: state => state.news.newsId,
  headerTitle: state => state.method.headerTitle,
  manShu: state => state.main.manShu,
  liXiu: state => state.main.liXiu,
  haoTong: state => state.main.haoTong,
  meiTi: state => state.main.meiTi,
  aiNose: state => state.main.aiNose,
}
export default getters
